
import jcoteckVTU1 from '../../assets/jcoteckVTU1.png'
import jcoteckVTU from '../../assets/jcoteckVTU.png'
import '../../styles/About.css'


export default function About() {
    return (
        <section className='about-section' id='about-section'>
            <div>
                <h1 className='about-h1' data-aos="zoom-in" >About Us</h1>
                <h2 className='about-h2 text-gray ' data-aos="fade-up" data-aos-duration="1200">Learn about our services</h2>
                <div className='about-div flex  '>
                    <p className='about-p ' data-aos="fade-right" data-aos-duration="1400">
                        JcoteckVTU is a reliable virtual top-up platform that provides fast, secure, and affordable services for all your digital needs. With JcoteckVTU, you can conveniently purchase cheap data subscriptions, buy airtime for all networks, and pay electricity bills seamlessly. The platform also supports WAEC and NECO scratch card purchases, along with other essential utility services, all in one place. Designed for ease of use and efficiency, JcoteckVTU ensures instant delivery, competitive pricing, and a smooth user experience, making it your go-to solution for everyday digital payments and utility transactions.
                    </p>
                    <div className='about-img-container '>
                        <div className='about-img-circle ' data-aos="fade-up" data-aos-duration="1600"></div>
                        <img data-aos="fade-right" className='about-img about-img1 w-auto h-56 ' src={jcoteckVTU} data-aos-duration="1800" alt="About us 1" />
                        <img data-aos="fade-left" className='about-img about-img2 w-auto h-56' src={jcoteckVTU1} data-aos-duration="1800" alt="About us 2" />
                    </div>
                </div>
            </div>
        </section>
    );
}